import { z } from "zod";

export const memberSchema = z.object({ id: z.string(), username: z.string(), email: z.string(), role: z.enum(["STUDENT", "EDUCATOR_ADMIN"]), status: z.enum(["ACTIVE", "DISABLED"]), registrantName: z.string(), companyName: z.string().nullable().optional(), rowVersion: z.number().int() });
export const memberPageSchema = z.object({ items: z.array(memberSchema), nextCursor: z.string().nullable().optional() });
export const createAdminSchema = z.object({ username: z.string().regex(/^[A-Za-z0-9]{6,30}$/), email: z.string().email(), password: z.string().min(6), registrantName: z.string().trim().min(1) });
export type Member = z.infer<typeof memberSchema>;
export type CreateAdmin = z.infer<typeof createAdminSchema>;

